export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_21-23a1eef30b4820dac41e4e2681a666fa.jpg";